<template>
  <v-card>
    <v-card-title>
      <v-icon class="service-status">{{ serviceStatus }}</v-icon>
      <b>Status:</b>

      <span v-if="status.lastLogTime">
        Last activity: {{ status.lastLogTime | formatDateTime }}
      </span>
      <span v-else>Unknown</span>
      <span class="tags suspended" v-if="userService.lineStatus === 'Suspended'"> Service Suspended</span>
      <span class="tags deleted" v-if="userService.isDeleted"> Service Deleted</span>

    </v-card-title>
    <v-divider class="mx-4"></v-divider>
  </v-card>
</template>

<script>
export default {
  name: "ServiceStatus",
  data: () => ({
    startDate: null,
    endDate: null,
    menu1: false,
    menu2: false,
    active: "mdi-wifi-strength-4",
    inactive: "mdi-wifi-off",
    downloads: 0,
    uploads: 0,
    total: 0,
  }),
  props: {
    userService: {
          type: Object,
          required: true,
          default: () => {
            return {};
          }
        }
  },

  computed: {
    serviceStatus() {
      if (this.status && this.status.successfulAuth == true)
        return "mdi-wifi-strength-4";
      else return "mdi-wifi-strength-outline";
    },
  },
};
</script>

<style lang="scss" scoped>
.summary-box {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  width: 100%;
  padding: 20px;
  color: #fff;

  & > p {
    margin-bottom: 0;
  }
}
.service-status {
  margin-right: 4px;
  top: -3px;
}
.service-status.mdi-wifi-strength-4 {
  color: #4caf50;
}
.service-status.mdi-wifi-off {
  color: #f44336;
}

.tags {
  font-size: 12px;
  padding: 2px 6px;
  border-radius: 4px;
  margin: auto auto auto 1rem;
}

.suspended{
  border: 1px solid red;
  color: red;
}

.deleted{
  border: 1px solid gray;
  color: gray;
}
</style>

